import { render, staticRenderFns } from "./ActualizacionFechaImputacion.vue?vue&type=template&id=2d2c5cc3&"
import script from "./ActualizacionFechaImputacion.vue?vue&type=script&lang=js&"
export * from "./ActualizacionFechaImputacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports